function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { LOCALE_INFO_SHAPE_PROP_TYPE, LINKS_DATA_SHAPE_PROP_TYPE } from './constants';
import { getMainSections } from './utils';

var _getMarketingLinkItems = function _getMarketingLinkItems(links) {
  if (links === void 0) {
    links = [];
  }

  return links.map(function (_ref) {
    var _classnames;

    var content = _ref.content,
        url = _ref.url,
        _ref$additionalClassN = _ref.additionalClassName,
        additionalClassName = _ref$additionalClassN === void 0 ? '' : _ref$additionalClassN,
        linkProps = _objectWithoutPropertiesLoose(_ref, ["content", "url", "additionalClassName"]);

    var className = classnames('eds-global-footer__link', (_classnames = {}, _classnames[additionalClassName] = additionalClassName, _classnames));
    return React.createElement("li", {
      key: content
    }, React.createElement("a", _extends({
      href: url
    }, linkProps, {
      className: className
    }), content));
  });
};

var _getMarketingLinks = function _getMarketingLinks(linkTypes) {
  return linkTypes.map(function (_ref2) {
    var title = _ref2.title,
        links = _ref2.links;
    return React.createElement("div", {
      key: title,
      className: "eds-g-cell eds-g-cell-3-12 eds-l-pad-left-6 eds-l-pad-top-4"
    }, React.createElement("h3", {
      className: "eds-l-pad-vert-2"
    }, title), React.createElement("ul", {
      className: "eds-l-pad-vert-2 eds-l-mar-all-0 eds-l-pad-hor-0"
    }, _getMarketingLinkItems(links)));
  });
};

var MarketingSection =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(MarketingSection, _React$Component);

  function MarketingSection() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MarketingSection.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        localeInfo = _this$props.localeInfo,
        serverUrl = _this$props.serverUrl,
        popularSearches = _this$props.popularSearches,
        eventsToPlan = _this$props.eventsToPlan,
        thirdFooterColumn = _this$props.thirdFooterColumn,
        thirdFooterColumnName = _this$props.thirdFooterColumnName;

    var marketingLinks = _getMarketingLinks(getMainSections(serverUrl, localeInfo, popularSearches, eventsToPlan, thirdFooterColumn, thirdFooterColumnName));

    return React.createElement("div", {
      className: "eds-bg-color--grey-900 eds-hide-sw eds-hide-sm eds-hide-sn"
    }, marketingLinks);
  };

  return MarketingSection;
}(React.Component);

_defineProperty(MarketingSection, "propTypes", {
  serverUrl: PropTypes.string.isRequired,
  localeInfo: LOCALE_INFO_SHAPE_PROP_TYPE.isRequired,
  popularSearches: LINKS_DATA_SHAPE_PROP_TYPE.isRequired,
  eventsToPlan: LINKS_DATA_SHAPE_PROP_TYPE.isRequired,
  thirdFooterColumn: LINKS_DATA_SHAPE_PROP_TYPE.isRequired,
  thirdFooterColumnName: PropTypes.string.isRequired
});

export { MarketingSection as default };